<script setup>
import { onClickOutside } from '@vueuse/core';
import { WdsPillSelect } from '@wds/components';

const props = defineProps({
  isMenuOpen: {
    type: Boolean,
    default: false,
  },
  iconEnd: {
    type: String,
    default: () => '',
  },
  iconStart: {
    type: String,
    default: () => '',
  },
  ariaLabel: {
    type: String,
    default: () => '',
  },
  text: {
    type: String,
    default: () => '',
  },
});

const emit = defineEmits(['pillMenuClick', 'pillMenuClickOutside']);
const menuContainer = ref(null);

onClickOutside(menuContainer, () => closeMenu());

function onClick() {
  emit('pillMenuClick');
}

function closeMenu() {
  emit('pillMenuClickOutside');
}
</script>

<template>
  <div
    ref="menuContainer"
    class="menu-container"
  >
    <WdsPillSelect
      :icon-start="props?.iconStart"
      :icon-end="props?.iconEnd"
      :aria-label="props?.ariaLabel"
      :text="props?.text"
      @click="onClick"
    />
    <div
      v-if="isMenuOpen"
      class="menu"
    >
      <slot name="menu" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.menu-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
